import React, { Component } from 'react';
import Modal from 'react-responsive-modal';
import { Link } from 'react-router-dom';

class CampaignPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true,
    };
  }

  onCloseModal = () => {
    this.setState({ open: false });
    if (this.props.onClose) {
      this.props.onClose();
    }
  };

  render() {
    const { campaign, banner, products, symbol, onAddToCart } = this.props;

    if (!campaign) {
      return null;
    }

    return (
      <Modal
        open={this.state.open}
        onClose={this.onCloseModal}
        center
        classNames={{
          modal: 'campaign-modal',
          overlay: 'campaign-modal-overlay',
        }}
        styles={{
          modal: {
            maxWidth: '900px',
            width: '90%',
            padding: '0',
            borderRadius: '12px',
          },
          overlay: {
            background: 'rgba(0, 0, 0, 0.75)',
          }
        }}
      >
        <div className="campaign-popup-content">
          {banner && banner.image && (
            <div className="campaign-banner">
              <img
                src={banner.image}
                alt={banner.name || campaign.campaign_name}
                style={{
                  width: '100%',
                  borderRadius: '12px 12px 0 0',
                  maxHeight: '400px',
                  objectFit: 'cover'
                }}
              />
            </div>
          )}

          <div className="campaign-info" style={{ padding: '30px' }}>
            <div style={{ textAlign: 'center', marginBottom: '20px' }}>
              <h3 style={{ marginBottom: '10px' }}>{campaign.campaign_name}</h3>
              {campaign.discount_percentage > 0 && (
                <h4 style={{ color: '#28a745', margin: '10px 0' }}>
                  {campaign.discount_percentage}% de descuento
                </h4>
              )}
              {campaign.active_until && (
                <p style={{ color: '#6c757d', fontSize: '14px' }}>
                  Válido hasta:{' '}
                  {new Date(campaign.active_until).toLocaleDateString('es-ES')}
                </p>
              )}
            </div>

            {products && products.length > 0 && (
              <div className="campaign-products">
                <h5 style={{ textAlign: 'center', marginBottom: '20px' }}>
                  Productos en promoción
                </h5>
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                  gap: '20px',
                  marginBottom: '20px'
                }}>
                  {products.map((product, index) => (
                    <div key={index} style={{
                      border: '1px solid #e0e0e0',
                      borderRadius: '8px',
                      overflow: 'hidden',
                      transition: 'transform 0.2s'
                    }}>
                      <Link
                        to={`${process.env.PUBLIC_URL}/left-sidebar/product/${product.id}`}
                        onClick={this.onCloseModal}
                      >
                        <img
                          src={product.image_1 || product.url}
                          alt={product.name}
                          style={{
                            height: '200px',
                            objectFit: 'cover',
                            width: '100%',
                          }}
                        />
                      </Link>
                      <div style={{ padding: '15px', textAlign: 'center' }}>
                        <Link
                          to={`${process.env.PUBLIC_URL}/left-sidebar/product/${product.id}`}
                          onClick={this.onCloseModal}
                          style={{ textDecoration: 'none', color: '#333' }}
                        >
                          <h6 style={{ marginBottom: '10px', fontSize: '14px' }}>
                            {product.name}
                          </h6>
                        </Link>
                        <div>
                          <h4 style={{ margin: '5px 0', fontSize: '18px' }}>
                            {symbol}{product.price_discount.toFixed(2)}
                            {product.price > product.price_discount && (
                              <del style={{ marginLeft: '10px', color: '#999', fontSize: '14px' }}>
                                {symbol}{product.price.toFixed(2)}
                              </del>
                            )}
                          </h4>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            <div style={{ textAlign: 'center', marginTop: '20px' }}>
              <Link
                to={`${process.env.PUBLIC_URL}/campaign/${campaign.campaign_uid}`}
                className="btn btn-solid"
                onClick={this.onCloseModal}
                style={{ marginRight: '10px', padding: '12px 30px' }}
              >
                Ver productos en promoción
              </Link>
              <button
                className="btn btn-outline"
                onClick={this.onCloseModal}
                style={{ padding: '12px 30px' }}
              >
                Continuar comprando
              </button>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

export default CampaignPopup;
